module.exports = __webpack_public_path__ + "static/media/24.58ec66ff.mp3";